/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Producer_NameInputs */

const en_producer_name = /** @type {(inputs: Producer_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Producer name`)
};

const es_producer_name = /** @type {(inputs: Producer_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre del productor`)
};

/**
* | output |
* | --- |
* | "Producer name" |
*
* @param {Producer_NameInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const producer_name = /** @type {((inputs?: Producer_NameInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Producer_NameInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_producer_name(inputs)
	return es_producer_name(inputs)
});